import { useEffect } from 'react';

export const ACTIVE_LISTINGS_POLL_INTERVAL_MS = 7_000;

/** Refreshes `collection` every interval while `hasActive`, skipping hidden tabs. */
export default function useActiveListingsPolling(
  collection: { refreshActiveListings(): Promise<void> },
  hasActive: boolean,
): void {
  useEffect(() => {
    if (!hasActive) {
      return undefined;
    }

    function tick(): void {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        return;
      }
      collection.refreshActiveListings().catch(() => undefined);
    }

    const intervalId = globalThis.setInterval(tick, ACTIVE_LISTINGS_POLL_INTERVAL_MS);
    return (): void => {
      globalThis.clearInterval(intervalId);
    };
  }, [hasActive, collection]);
}
